export const SENDING_FEEDBACK = 'auth/SENDING_FEEDBACK'
export const SENDING_FEEDBACK_FAIL = 'auth/SENDING_FEEDBACK_FAIL'
export const SENDING_FEEDBACK_SUCCESS = 'auth/SENDING_FEEDBACK_SUCCESS'
